import { LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import type { Commerce } from "@teqtank/commerce-sdk";

@customElement("teqtank-storefront-context")
export class TeqtankStorefrontContext extends LitElement {
    @property({ attribute: false }) public accessor commerce: Commerce | undefined;
    @property({ attribute: "web-alias" }) public accessor webAlias = "";
    @property() public accessor campaign = "";
    @property() public accessor url = "";

    protected override createRenderRoot(): HTMLElement | DocumentFragment {
        return this;
    }

    protected override updated(changed: Map<PropertyKey, unknown>): void {
        if (
            changed.has("commerce") ||
            changed.has("webAlias") ||
            changed.has("campaign") ||
            changed.has("url")
        )
            void this.resolve();
    }

    private async resolve(): Promise<void> {
        if (!this.commerce) return;
        const location = this.url
            ? this.url
            : typeof window !== "undefined"
              ? window.location.href
              : undefined;
        const request = {
            ...(location ? { url: location } : {}),
            ...(this.webAlias ? { webAlias: this.webAlias } : {}),
            ...(this.campaign ? { campaign: this.campaign } : {}),
            ...(typeof document !== "undefined" && document.referrer
                ? { referrer: document.referrer }
                : {}),
        };
        if (this.webAlias) {
            await this.commerce.storefront.resolve(request);
        } else {
            await this.commerce.storefront.resolveLocation(location, {
                ...(this.campaign ? { campaign: this.campaign } : {}),
                ...(request.referrer ? { referrer: request.referrer } : {}),
            });
        }
        this.dispatchEvent(
            new CustomEvent("teqtank-storefront-ready", {
                detail: this.commerce.storefront.current,
                bubbles: true,
                composed: true,
            }),
        );
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "teqtank-storefront-context": TeqtankStorefrontContext;
    }
}
